export default {
  metadata: {
    version: '1.0.0',
    id: 'tag-1.0.0',
    name: 'JDSTag',
    description:
      'Tags are keywords used to describe, categorize, or filter content.',
    usage:
      'Use tags when content is mapped to multiple categories, and the user needs a way to differentiate between them.'
  },
  hierarchy: {
    container: ['jds-text', 'icon']
  },
  base: {
    container: {
      hidden: false,
      display: 'flex',
      'flex-direction': '{t_0}',
      'justify-content': '{t_1}',
      'align-items': '{t_2}',
      'padding-top': '{t_3}',
      'padding-left': '{t_4}',
      'padding-right': '{t_5}',
      'padding-bottom': '{t_6}',
      gap: '{t_7}',
      'background-color': '{t_8}',
      'border-radius': '{t_9}',
      'border-width': '{t_10}',
      'border-color': '{t_11}',
      opacity: '{t_30}',
      behavior: {
        active: {
          'border-color': '{t_13}'
        },
        focus: {
          'border-color': '{t_14}',
          'border-width': '{t_15}'
        },
        hover: {
          'border-color': '{t_12}'
        }
      }
    },
    icon: {
      hidden: true,
      size: '{t_16}',
      color: '{t_17}',
      behavior: {
        hover: {
          color: '{t_18}'
        },
        active: {
          color: '{t_19}'
        },
        focus: {
          color: '{t_20}'
        }
      }
    },
    'jds-text': {
      'font-family': '{text_132}',
      color: '{text_20}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      hidden: false,
      maxLines: 1,
      behavior: {
        hover: {
          color: '{text_39}'
        },
        active: {
          color: '{text_39}'
        },
        focus: {
          color: '{text_39}'
        }
      }
    }
  },
  variant: {
    size: {
      small: {
        container: {
          'padding-top': '{t_31}',
          'padding-left': '{t_32}',
          'padding-right': '{t_33}',
          'padding-bottom': '{t_34}'
        },
        'jds-text': {
          'font-family': '{text_147}',
          'font-size': '{text_146}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}'
        }
      }
    },
    kind: {
      filter: {
        icon: {
          hidden: false
        }
      }
    },
    active: {
      true: {
        container: {
          'background-color': '{t_23}',
          'border-width': '{t_21}',
          'border-color': '{t_22}',
          behavior: {
            hover: {
              'background-color': '{t_24}'
            },
            active: {
              'background-color': '{t_25}',
              'border-color': '{t_26}',
              'border-width': 1
            },
            focus: {
              'background-color': '{t_27}'
            }
          }
        },
        icon: {
          color: '{t_28}',
          value: 'ic_close'
        },
        'jds-text': {
          color: '{text_39}'
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{t_29}'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      icon: {
        value: {
          type: 'icon',
          name: 'icon',
          function: true
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays label of Tag.'
        }
      }
    },
    config: {
      size: {
        values: ['medium', 'small'],
        doc_description: 'It can be used to control size of Tag.'
      },
      kind: {
        values: ['toggle', 'filter'],
        doc_description: 'It can be used to switch between 2 variants of Tag.'
      },
      disabled: {
        values: [false, true],
        doc_description: 'It can be used to enable or disable Tag.'
      },
      active: {
        values: [false, true],
        doc_description: 'This can be used to activate Tag.'
      }
    },
    events: {
      container: {
        onClick: 'onClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'button'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-pressed': {
            name: '_ariaPressed',
            prop: 'active'
          }
        }
      }
    }
  }
};
